import { CLOUD_LAUNCH_PROMO } from '@/data/cloud';
const en = {
  m000: "Powering Data APIs with Arrow Flight RPC and Ibis",
  m001: "In this article, we'll demonstrate how you can use a Apache Arrow Flight RPC API server powered by Ibis to create fast, efficient data APIs.",
  m002: "OLAP Hierarchical Aggregation with SQL",
  m003: "Aggregation for dimensional hierarchies doesn't require costly Business Intelligence (BI) tools. You can implement this efficiently with SQL.",
  m004: "Articles",
  m005: "Insights and technical knowledge from our team",
  m006: "by",
  m007: "Read on Medium",
};
export type Messages = typeof en;
export const messages = { en, 'pt-BR': {
  m000: "APIs de dados com Arrow Flight RPC e Ibis",
  m001: "Neste artigo, mostramos como usar um servidor de API Apache Arrow Flight RPC baseado em Ibis para criar APIs de dados rápidas e eficientes.",
  m002: "Agregação hierárquica OLAP com SQL",
  m003: "A agregação de hierarquias dimensionais não exige ferramentas caras de Business Intelligence (BI). Você pode implementá-la de forma eficiente com SQL.",
  m004: "Artigos",
  m005: "Insights e conhecimento técnico da nossa equipe",
  m006: "por",
  m007: "Leia no Medium",
} satisfies Messages };
